// 简体中文（默认）

export default {
  app: {
    name: '隐分宝',
    shortSlogan: '安安静静 看个回放！'
  },

  // 产品文案唯一真相源。所有页面/SEO/JSON-LD 的产品介绍文案必须从这里取，
  // 不要在别处另写一份。引用方式：`@:product.shortIntro` / `@:product.longIntro` /
  // `@:product.aboutIntro` / `@:product.capabilities`。
  // 见 docs/mainadr/0008-shared-product-copy.md。
  product: {
    shortIntro: '隐分宝是一个在观看体育赛事回放时，自动隐藏比赛回放页面下的比分、封面、标题、评论等剧透信息的浏览器扩展（插件），支持 Chrome、Edge、Firefox 三浏览器。',
    longIntro: '隐分宝是一个在观看体育赛事回放时，自动隐藏比赛回放页面下的比分、封面、标题、评论等剧透信息的浏览器扩展（插件），可以在观看回放时免被任何剧透信息干扰！',
    aboutIntro: '隐分宝（Replay Shield）是一款浏览器扩展，自动隐藏主流体育视频网站的赛事比分和剧透信息，帮助你在观看比赛回放或集锦时保留观赛悬念。所有识别与隐藏逻辑均在本地浏览器执行，数据不出端。',
    capabilities: [
      '一键开关：总开关即时切换，所有受支持的站点全局生效',
      '信息隐藏：自动隐藏标题、封面、比分、评论等剧透元素',
      '加载遮罩：页面加载完成后才解除进度条遮罩',
      '开头遮挡：播放前遮挡面板盖住画面，避免开局剧透',
      '本地优先：所有逻辑在您的浏览器内执行，偏好不离开设备'
    ]
  },

  slogan: '体育赛事回放剧透信息隐藏助手',

  nav: {
    home: '首页',
    features: '功能特性',
    install: '安装指南',
    guide: '使用说明',
    matrix: '终端支持',
    faq: '常见问题',
    about: '关于',
    privacy: '隐私',
    terms: '协议',
    download: '下载',
    login: '登录',
    account: '账号',
    accountCenter: '个人中心',
    subscribe: 'Pro 会员',
    upgradeCta: '开通 Pro 会员'
  },

  seo: {
    siteName: '隐分宝',
    shortName: 'Replay Shield',
    description: '@:product.shortIntro',
    keywords: '隐分宝,Replay Shield,比分隐藏,剧透隐藏,体育回放,浏览器扩展,Chrome 扩展,Edge 扩展,Firefox 扩展',
    ogImage: '/og/default.png',

    home: {
      title: '隐分宝 — 体育赛事回放剧透信息隐藏助手',
      description: '@:product.longIntro'
    },
    install: {
      title: '安装指南 — 隐分宝',
      description: '隐分宝支持 Chrome / Edge / Firefox 三浏览器商店一键安装，以及 360、QQ、猎豹、Opera 等其他浏览器手动 .crx 安装。'
    },
    guide: {
      title: '使用说明 — 隐分宝',
      description: '装完隐分宝后怎么用？三步进入管理控制台开始观赛；赛事导航、遮罩层、开头遮挡、进度条防护等观赛设置详解，足球与篮球赛事通用的使用说明。'
    },
    about: {
      title: '关于隐分宝',
      description: '@:product.aboutIntro'
    },
    subscribe: {
      title: 'Pro 会员 — 隐分宝',
      description: '隐分宝 Pro 会员：免费档覆盖第三方赛事导航，Pro 会员解锁国内外赛事导航与完整剧透防护。新用户注册即享 {days} 天 Pro 试用，月度 / 季度 / 年度三档方案，邀请好友双方都有好礼，支持兑换码兑换。',
      descriptionMeta: '隐分宝 Pro 会员：免费档覆盖第三方赛事导航，Pro 会员解锁国内外赛事导航与完整剧透防护。新用户注册即享 Pro 试用，月度 / 季度 / 年度三档方案，邀请好友双方都有好礼，支持兑换码兑换。'
    },
    login: {
      title: '登录 — 隐分宝',
      description: '登录隐分宝账号，同步观赛防护设置与 Pro 会员权益；支持邮箱密码登录与 QQ、抖音、Google 第三方登录。'
    },
    account: {
      title: '个人中心 — 隐分宝',
      description: '管理你的隐分宝账号：订阅权益、订单记录、邀请奖励与账号安全设置。'
    },
    privacy: {
      title: '隐私政策 — 隐分宝',
      description: '隐分宝尊重并保护所有用户的隐私。本政策说明我们如何收集、使用和保护您的信息。'
    },
    terms: {
      title: '用户协议 — 隐分宝',
      description: '隐分宝（Replay Shield）用户协议。请仔细阅读，使用本产品即视为您同意本协议全部条款。'
    },
    refund: {
      title: '退款政策 — 隐分宝',
      description: '隐分宝 Pro 会员订阅退款政策：虚拟数字商品不支持无理由全额退款；特殊情况经运营方核实开放退款权限后，按已使用天数比例清算退款。'
    },
    inviteRules: {
      title: '邀请规则 — 隐分宝',
      description: '隐分宝邀请规则：好友通过你的邀请注册双方都有好礼，注册 +5 天、好友首次订阅再得一半时长；了解绑定规则、受邀折扣与退款收回口径。'
    },

  notFound: {
      title: '页面未找到 — 隐分宝',
      description: '您访问的页面不存在或已被移除。'
    }
  },

  home: {
    hero: {
      title: '比分已藏 · 悬念犹在',
      subtitle: '安安静静 看个回放！',
      painLine: '熬不了夜？看回放又被剧透？',
      intro: '@:product.longIntro',
      sellPoints: [
        '剧透自动隐藏',
        '足球篮球双支持',
        '免费观赛导航神器'
      ],
      cta: {
        recommendedFor: '为当前浏览器推荐',
        detectedCta: '前往 {browser} 商店安装',
        storeGeneric: '前往应用商店安装',
        installGuide: '前往安装指南',
        fallbackHint: '不是 {browser}？查看其他浏览器',
        fallbackHintGeneric: '选择其他安装方式',
        fallbackLabel: '选择浏览器',
        manualCta: '其他浏览器手动安装',
        manualHint: '适用于 360 极速 / QQ / 搜狗 / 猎豹 / Opera / UC 等',
        availableOn: '支持浏览器',
        seeAll: '查看所有下载方式',
        crx: '查看手动安装指南',
        stores: {
          chrome: 'Chrome应用商店',
          edge: 'Edge应用商店',
          firefox: 'Firefox应用商店'
        }
      }
    },

    sections: {
      features: '功能特性',
      matrix: '终端支持',
      preview: '效果对比',
      quickStart: '快速上手',
      faq: '常见问题',
      sites: '支持站点',
      sitesSubtitle: '这些主流平台上的足球、篮球赛事回放，均可隐藏剧透信息',
      useCases: '谁需要隐分宝'
    },

    features: {
      title: '功能特性',
      subtitle: '覆盖观看体育回放的全部需求，足球与篮球通吃',
      cards: [
        {
          id: 'match-list',
          title: '赛事导航',
          subtitle: '一键观赛',
          desc: '集中展示世界杯、欧冠、英超、西甲、意甲、法甲、德甲与 NBA、CBA 等热门足球、篮球赛事，每场比赛下列出全场回放、分节视频与集锦，标注来源平台与解说。',
          icon: 'ph:list-bold'
        },
        {
          id: 'info-hide',
          title: '信息隐藏',
          subtitle: '无剧透浏览',
          desc: '打开目标网页后，自动隐藏视频标题、封面、简介、评论与浏览器 TITLE 等剧透元素。整页打开就是干净的回放体验。',
          icon: 'ph:eye-slash-bold',
          highlight: true
        },
        {
          id: 'progressive',
          title: '渐进式展示',
          subtitle: '节奏自控',
          desc: '比赛列表默认展示回放与集锦，附加视频默认折叠。先看常规，结束再决定是否展开，按自己的节奏推进，不剧透。',
          icon: 'ph:caret-down-bold'
        },
        {
          id: 'mask',
          title: '加载遮罩',
          subtitle: '瞬间防剧透',
          desc: '页面打开时叠加进度条遮罩，防止页面加载瞬间比分与剧透文字闪现。让干净的回放体验从第一帧开始。',
          icon: 'ph:shield-bold'
        },
        {
          id: 'cover-intro',
          title: '视频开头遮挡面板',
          subtitle: '开局防剧透',
          desc: '视频播放前 N 秒显示遮挡面板盖住播放器画面，防止集锦开头出现比分剧透。按设置秒数生效。',
          icon: 'lucide:monitor-play'
        },
        {
          id: 'skip-buttons',
          title: '快进快退浮动按钮',
          subtitle: '节奏自控',
          desc: '开启后显示快进快退浮动按钮，支持自定义时长，自由控制画面的快进、快退。',
          icon: 'ph:fast-forward-bold'
        },
        {
          id: 'progress-protection',
          title: '进度条防护',
          subtitle: '时长防推断',
          desc: '隐藏视频进度条、总时长与结束时间，避免通过时长推断比赛阶段与结果。',
          icon: 'lucide:timer'
        }
      ],
      ctaSubscribe: {
        title: '部分 Pro 会员专属功能需订阅',
        desc: '所有用户均可免费观看最新热门足球、篮球回放赛事，基础功能免费使用。开通 Pro 会员解锁剧透隐藏、开头遮挡、进度条防护等更多能力，新用户注册即享 Pro 试用。',
        cta: '查看 Pro 会员方案'
      }
    },

    quickStart: {
      subtitle: '三步开始观赛；不同设备的完整步骤见安装指南。',
      deviceTabs: { desktop: '电脑端', mobile: '手机端' },
      notice: '友情提示：隐分宝只对从控制台赛事导航打开的网页生效剧透遮挡，对其他来源打开的网站不生效。',
      ctaInstall: '查看完整安装指南',
      ctaGuide: '功能与设置详解',
      steps: {
        desktop: [
          {
            title: '安装扩展',
            desc: '在 Chrome / Edge / Firefox 商店一键安装，或手动安装 .crx。'
          },
          {
            title: '进入管理控制台',
            desc: '点击工具栏的隐分宝图标，在弹出小窗里点「进入管理控制台」。'
          },
          {
            title: '从赛事导航观赛',
            desc: '选一场足球或篮球比赛点击前往，比分、标题自动隐藏。'
          }
        ],
        mobile: [
          {
            title: '安装浏览器与扩展',
            desc: '手机端用 Edge 或 Firefox：在扩展菜单中搜索隐分宝并安装。'
          },
          {
            title: '进入管理控制台',
            desc: '在扩展菜单点击隐分宝，弹出界面点「进入管理控制台」。'
          },
          {
            title: '从赛事导航观赛',
            desc: '选一场比赛点击前往，剧透信息自动隐藏。'
          }
        ]
      }
    },

    useCases: {
      title: '谁需要隐分宝',
      subtitle: '真实使用场景下的人群画像',
      cases: [
        {
          icon: 'lucide:briefcase',
          title: '第二天要上班的学生与上班族',
          desc: '早九晚五的生活节奏让人无法熬夜追直播，第二天看重播又被标题、封面、评论里的剧透信息干扰。'
        },
        {
          icon: 'ph:trophy-bold',
          title: '热爱体育的资深球迷',
          desc: '无论看英超、欧冠、世界杯还是 NBA，都希望保留「直播般的悬念感」。隐分宝让回放也有第一次看球的心跳。'
        },
        {
          icon: 'lucide:monitor-play',
          title: '手机端长视频观看者',
          desc: '通勤、外出、睡前用手机看重播与集锦的人。手机端同样支持完整的剧透隐藏。'
        }
      ]
    },

    whatIsYfb: {
      eyebrow: 'WHAT IS REPLAY SHIELD',
      title: '什么是隐分宝',
      lead: '当错过体育赛事直播，想要重温体育赛事回放时，却看到比分、标题、封面、评论里都充满着剧透信息。这总是会让体育爱好者失去观赛乐趣！',
      pains: [
        {
          icon: 'lucide:moon',
          title: '熬不了夜',
          desc: '工作日没法熬夜追直播，第二天看重播时比分早已在标题、封面、推送里刷过一遍，悬念全无。'
        },
        {
          icon: 'lucide:tv',
          title: '错过直播',
          desc: '几天后才补看世界杯决赛、欧冠半决赛或 NBA 抢七大战，社交媒体与新闻标题早已满屏剧透，点开页面就被结果迎面砸来。'
        },
        {
          icon: 'lucide:message-square-warning',
          title: '被剧透包围',
          desc: '视频封面的「全场 3-1」、标题里的「冠军诞生」、评论区里的「太强了哈兰德」「绝杀太燃了」——每一个元素都在剧透。'
        }
      ],
      introTag: 'INTRO',
      intro: '隐分宝是一个在观看体育赛事回放时，自动隐藏比赛回放页面下的比分、封面、标题、评论等剧透信息的浏览器扩展（插件），可以在观看回放时免被任何剧透信息干扰！'
    },

    preview: {
      title: '效果预览',
      subtitle: '看看隐分宝如何在不同设备上守护你的观赛悬念',
      beforeLabel: '启用插件前',
      afterLabel: '启用插件后',
      beforeHint: '比分清晰可见',
      afterHint: '比分已被隐藏',
      switchHint: '点击切换查看效果',
      mockPage: {
        pageTitle: '热门赛事 · 回放列表',
        siteLabel: '示例站点',
        badgeSpoiler: '剧透可见',
        badgeProtected: '已保护',
        statusToggle: '插件状态',
        statusOn: '已启用',
        statusOff: '已关闭',
        placeholder: {
          title: '[隐分宝：标题]',
          score: '[隐分宝：比分]',
          thumbnail: '[隐分宝：封面]',
          comment: '[隐分宝：评论]',
          league: '[隐分宝：联赛]'
        },
        matches: [
          {
            league: '英超第 28 轮',
            homeTeam: '曼城',
            awayTeam: '利物浦',
            homeShort: 'MNC',
            awayShort: 'LIV',
            homeScore: 3,
            awayScore: 1,
            status: '已结束',
            time: '04-12 · 23:30',
            title: '曼城 3-1 利物浦 · 哈兰德双响 萨拉赫扳回一城',
            thumbnailLabel: '回放封面',
            comments: ['太强了哈兰德！', '利物浦下半场崩了', '曼城冠军稳了']
          },
          {
            league: '西甲第 30 轮',
            homeTeam: '皇马',
            awayTeam: '巴萨',
            homeShort: 'RMA',
            awayShort: 'BAR',
            homeScore: 2,
            awayScore: 2,
            status: '已结束',
            time: '04-13 · 03:00',
            title: '国家德比 2-2 战平 维尼修斯绝平',
            thumbnailLabel: '回放封面',
            comments: ['国家德比永远精彩', '维尼修斯是真核', '巴萨防线堪忧']
          },
          {
            league: 'NBA 季后赛',
            homeTeam: '湖人',
            awayTeam: '勇士',
            homeShort: 'LAL',
            awayShort: 'GSW',
            homeScore: 112,
            awayScore: 108,
            status: '已结束',
            time: '04-14 · 10:30',
            title: '湖人 112-108 险胜勇士 詹姆斯三双',
            thumbnailLabel: '回放封面',
            comments: ['老詹还是稳', '库里差一点点', '湖人总冠军？']
          },
          {
            league: '欧冠 1/4 决赛',
            homeTeam: '拜仁',
            awayTeam: '阿森纳',
            homeShort: 'BAY',
            awayShort: 'ARS',
            homeScore: 1,
            awayScore: 0,
            status: '已结束',
            time: '04-15 · 03:00',
            title: '拜仁 1-0 小胜阿森纳 凯恩头球制胜',
            thumbnailLabel: '回放封面',
            comments: ['阿森纳可惜了', '凯恩大场面先生', '次回合悬念还在']
          }
        ]
      }
    },

    matrix: {
      title: '终端支持',
      subtitle: '隐分宝目前已支持主流浏览器 + 主流操作系统',
      headers: ['Chrome', 'Edge', 'Firefox'],
      platforms: ['Windows / macOS', 'Android', 'iOS / iPadOS', 'HarmonyOS'],
      rows: [
        ['支持', '支持', '支持'],
        ['不支持', '支持', '支持'],
        ['不支持', '不支持', '不支持'],
        ['不支持', '支持', '支持']
      ],
      legend: {
        yes: '支持',
        limited: '部分支持',
        no: '不支持'
      }
    },

    faq: {
      title: '常见问题',
      subtitle: '关于隐分宝的常见疑问解答',
      items: [
        {
          q: '为什么启用后有些网站比分还显示？',
          a: '可能是该网站近期改版。可以通过页面底部的反馈渠道告诉我们，我们会尽快跟进适配。'
        },
        {
          q: '插件会不会影响网页其他功能？',
          a: '不会。插件只隐藏比分、标题、封面、评论等剧透相关元素，不影响视频播放和其他交互。'
        },
        {
          q: '支持篮球比赛吗？',
          a: '支持。隐分宝同时提供足球与篮球赛事导航（NBA、CBA 等），剧透隐藏能力对两类赛事同等生效，控制台左侧可随时切换。'
        },
        {
          q: '如何在启用状态下临时查看比分？',
          a: '可以暂时关闭插件开关，刷新页面后即可查看比分。'
        },
        {
          q: '移动端（iOS）为什么找不到扩展入口？',
          a: 'iOS 系统的浏览器内核受 Apple 限制，扩展能力有限。建议使用桌面端浏览器获得完整体验。'
        },
        {
          q: '本地安装后提示"无法验证扩展来源"是正常的吗？',
          a: '正常现象，这是浏览器的安全保护。选择"保留"即可继续使用。'
        },
        {
          q: '卸载插件会影响已保存的数据吗？',
          a: '不会。卸载插件仅移除扩展本身，不会影响浏览器其他数据。'
        }
      ]
    },

    meta: {
      title: '隐分宝 — 让回放也有直播体验',
      description: '体育赛事回放剧透信息隐藏助手，支持 Chrome、Edge、Firefox 三浏览器。'
    }
  },

  // 使用说明（how-to 操作手册 + 控制台功能详解）。与法律「使用说明/声明」(/terms#specific-features)
  // 严格区分，见 CONTEXT.md「使用指南 vs 使用说明」。文案须可执行、负责任，禁止空话。
  guide: {
    eyebrow: 'GUIDE · 使用说明',
    title: '使用说明',
    subtitle: '安装完成后，从这里开始：三步进入观赛，再了解控制台的每一项能力。',
    intro: '隐分宝的赛事导航与观赛设置都集中在「管理控制台」里：点击浏览器工具栏的隐分宝图标，在弹出小窗中点「进入管理控制台」即可进入。',
    installFirst: '还没装？先看安装指南',

    quick: {
      title: '三步开始观赛',
      mobileNote: '手机端（Android / HarmonyOS）：用 Edge 或 Firefox 安装后，在浏览器扩展菜单里点击隐分宝 → 「进入管理控制台」。iOS 暂不支持。',
      steps: [
        {
          title: '安装扩展',
          desc: '在 Chrome / Edge / Firefox 商店一键安装，或手动安装 .crx。'
        },
        {
          title: '进入管理控制台',
          desc: '点击工具栏的隐分宝图标，在弹出的小窗里点「进入管理控制台」。'
        },
        {
          title: '从赛事导航观赛',
          desc: '选一场足球或篮球比赛点击前往观赛，比分、标题、封面等剧透信息自动隐藏。'
        }
      ]
    },

    nav: {
      title: '赛事导航',
      intro: '控制台的赛事导航按「体育偏好」分为足球与篮球两类，两侧结构完全一致：',
      items: [
        {
          title: '足球 / 篮球切换',
          desc: '左侧菜单「赛事」分组下随时切换足球与篮球；两侧都是每日更新的已完赛赛事回放与集锦。'
        },
        {
          title: '频道与联赛筛选',
          desc: '顶部频道选择器切换国际 / 国内来源，联赛标签横向筛选，快速定位想看的比赛。'
        },
        {
          title: '视频分区',
          desc: '每场比赛下分「全场回放」「比赛集锦」等分区，标注来源平台与解说员，点开即看。'
        },
        {
          title: '收藏',
          desc: '登录后可整场收藏比赛，之后在左侧「收藏」中一键回看。'
        }
      ]
    },

    settings: {
      title: '观赛设置',
      intro: '在控制台左侧菜单进入「设置」，按个人需求调整（未登录或权益未生效时部分项会锁定）：',
      groups: [
        {
          title: '功能',
          items: [
            '开启插件：总开关，关闭后所有功能暂停',
            '遮罩层：0–10 秒可调，阻挡刚进入网页时的剧透闪现',
            '体育偏好：全部 / 足球 / 篮球',
            '桌面版网页：手机端以桌面版加载支持的站点（需手动开启）'
          ]
        },
        {
          title: '播放',
          items: [
            '视频开头遮挡面板：0–60 秒，盖住视频开头的比分画面',
            '隐藏结束时间 / 隐藏进度条：防止通过时长推断比赛走向',
            '快进快退面板：10 秒到 30 分钟共 6 档步长',
            '全屏锁屏：全屏观看时的辅助防护'
          ]
        },
        {
          title: '外观',
          items: [
            '配色：霓虹青 / 终端绿 / 电光蓝 / 幻影紫 / 落日金 / 晨曦白 六套',
            '界面语言：简体中文 / 繁體中文 / English'
          ]
        }
      ]
    },

    entitlement: {
      title: '免费与 Pro 会员',
      desc: '第三方赛事导航与赛事浏览（足球 / 篮球赛事列表、渐进式折叠、解说员标注）对所有用户免费开放；国内外赛事导航、剧透信息隐藏、加载遮罩、开头遮挡、进度条防护等为 Pro 会员能力。新用户注册即享 Pro 试用。',
      cta: '查看 Pro 会员方案'
    },

    scope: '友情提示：隐分宝只对从控制台赛事导航打开的网页生效剧透遮挡，对其他来源打开的任意网站不生效。'
  },

  footer: {
    copyright: '© 2026 隐分宝',
    brandDesc: '@:product.longIntro',
    sections: {
      product: '产品',
      legal: '法律',
      social: '关注我们'
    },
    links: {
      membership: 'Pro 会员',
      features: '功能特性',
      install: '安装指南',
      guide: '使用说明',
      matrix: '终端支持',
      download: '下载',
      about: '关于我们',
      faq: '常见问题',
      privacy: '隐私政策',
      terms: '用户协议',
      refund: '退款政策',
      invite: '邀请规则',
    },
    social: {
      wechatGzh: {
        title: '微信公众号',
        hint: '膨胀的球（搜索关注）'
      },
      wechatGroup: {
        title: '反馈交流群',
        hint: '用户反馈与交流'
      }
    }
  },

  common: {
    back: '返回',
    learnMore: '了解更多',
    getStarted: '立即开始',
    yes: '是',
    no: '否',
    loading: '加载中...',
    error: '出错了',
    retry: '重试',
    close: '关闭'
  },

  login: {
    title: '登录',
    email: '邮箱',
    emailPlaceholder: 'name\\@example.com',
    nickname: '昵称（可选）',
    nicknamePlaceholder: '怎么称呼你？',
    password: '密码',
    newPassword: '新密码',
    passwordPlaceholder: '8-20位，含大写字母、小写字母和数字',
    confirmPassword: '确认密码',
    confirmPasswordPlaceholder: '再次输入密码',
    passwordMismatch: '两次输入的密码不一致',
    passwordIncorrect: '密码不正确',
    showPassword: '显示密码',
    hidePassword: '隐藏密码',
    passwordStrength: '密码强度',
    passwordWeak: '弱',
    passwordMedium: '中',
    passwordStrong: '强',
    code: '验证码',
    codePlaceholder: '6位数字',
    sendCode: '发送验证码',
    codeSent: '验证码已发送，请查收邮件',
    resetSuccess: '密码重置成功，请使用新密码登录',
    sessionExpired: '登录已失效，请重新登录',
    kicked: '您的账号已在其他设备登出，请重新登录',
    submit: '提交',
    submitError: '操作失败，请稍后重试',
    privacyPolicy: '《隐私政策》',
    callbackTitle: '登录成功',
    callbackReturning: '正在返回隐分宝…',
    callbackCountdown: '即将自动返回隐分宝（{n} 秒）',
    callbackGoAccount: '前往个人中心',
    callbackOpenConsole: '打开隐分宝控制台',
    // 「网页端已登录」显式确认（ADR-0042）：不再静默自动续登，把选择权交给用户
    resumeTitle: '网页端已登录',
    resumeContinue: '继续以该账号登录',
    resumeSwitch: '更换账号',
    callbackReturnNow: '立即返回隐分宝',
    callbackWeakHint: '若长时间未返回，请在浏览器工具栏中点击隐分宝图标查看登录状态',
    rememberAccount: '记住账号',
    rememberPassword: '记住密码',
    agreePrefix: '已阅读并同意',
    terms: '《用户协议》',
    agreeAnd: '与',
    agreeRequired: '请先阅读并同意《用户协议》与《隐私政策》',
    sliderTitle: '安全验证',
    sliderHint: '拖动滑块，完成拼图',
    sliderLoading: '加载中…',
    sliderFail: '验证失败，请重试',
    sliderRefresh: '刷新',
    withQQ: '使用QQ登录',
    withDouyin: '使用抖音登录',
    withGoogle: '使用Google登录',
    backToLogin: '返回登录',
    forgotLink: '忘记密码？',
    goLogin: '已有账号？去登录',
    goRegister: '没有账号？立即注册',
    signIn: '登录',
    signUp: '注册',
    oauthDivider: '或使用第三方账号登录',
    oauthError: '第三方登录失败，请重试或使用邮箱密码登录'
  },

  cashier: {
    title: '完成支付',
    chooseChannel: '选择支付方式',
    payWechat: '微信支付',
    wechatDesc: '扫码支付',
    payAlipay: '支付宝',
    alipayDesc: '跳转支付宝收银台',
    days: '{days} 天',
    wechatTip: '请使用微信「扫一扫」识别二维码支付',
    alipayTip: '前往支付宝完成付款，支付成功后本页将自动确认结果。',
    alipayGo: '前往支付宝支付',
    wechatGo: '微信支付',
    wechatGoTip: '提交后将展示付款二维码，请使用微信扫码支付',
    initiating: '正在处理…',
    quoteRetry: '重试报价',
    originalPrice: '原价',
    reopen: '重新打开支付页',
    awaitingCheck: '打开支付页面完成支付后，将自动确认结果',
    pollChecking: '正在确认支付结果…',
    staleCheck: '确认超时，可刷新后继续等待或稍后在个人中心继续支付',
    refreshStatus: '支付完成？点此刷新',
    timeoutMsg: '长时间未确认，可尝试重建二维码或重新打开支付页',
    refreshQr: '重建二维码',
    doneTitle: '支付成功',
    doneDesc: '订阅已生效，感谢支持！浏览器扩展将同步解锁 Pro 会员权益。',
    doneCta: '好的',
    expiredTitle: '订单未完成',
    closedMsg: '订单已关闭，如需订阅请重新下单',
    okay: '知道了',
    discountTitle: '优惠选择',
    discountDefault: '默认最优',
    discountRecommend: '推荐',
    discountSave: '省 ¥{amount}',
    discount: {
      activity: '限时活动',
      inviteFirst: '受邀首单',
      firstOrder: '首订优惠',
      renewal: '续费优惠',
      noDiscount: '不使用优惠'
    },
    inviteBindDesc: '确认与 {name}（{account}）绑定邀请关系（终身、仅此一次）？',
    inviteAccept: '确认绑定',
    inviteDecline: '不绑定',
    consentNote: '支付即代表你已阅读并同意',
    consentTerms: '《用户协议》',
    consentAnd: '与',
    consentRefund: '《退款政策》'
  },
  account: {
    title: '个人中心',
    notLoggedIn: '你还未登录',
    sections: {
      benefits: '我的权益',
      invites: '我的邀请',
      orders: '我的订单',
      profile: '个人信息'
    },
    benefitsDesc: '查看 Pro 会员详情、兑换码使用记录与权益流水',
    invitesDesc: '查看你的邀请码与邀请产生的奖励流水',
    profileDesc: '管理你的昵称',
    ordersDesc: '查看订单进度与权益明细；特殊情况退款需先经客服核实开通权限',
    nickname: '昵称',
    email: '邮箱',
    edit: '修改',
    editNickname: '修改昵称',
    notBound: '未绑定',
    bindEmail: '绑定邮箱',
    passwordSet: '已设置',
    passwordNotSet: '未设置',
    password: '密码',
    changePassword: '修改密码',
    oldPassword: '原密码',
    newPassword: '新密码',
    deleteAccount: '注销账户',
    deleteHint: '注销后账号数据将被删除且不可恢复，请谨慎操作。',
    deleteConfirmPassword: '输入密码确认',
    deleteConfirm: '我已了解注销后果，确认注销',
    save: '保存',
    cancel: '取消',
    confirm: '确认',
    saved: '保存成功',
    emailSaved: '邮箱修改成功',
    emailBoundSaved: '邮箱绑定成功',
    passwordSaved: '密码修改成功，请重新登录',
    samePassword: '新密码不能与原密码相同',
    logout: '退出登录',
    logoutConfirm: '确定要退出登录吗？退出后将同时登出浏览器插件。',
    emailVerified: '已验证',
    operationError: '操作失败，请稍后重试',
    // 第三方账号绑定（ADR-0041）
    loginMethodsTitle: '登录方式',
    oauthHint: '绑定后可用该第三方账号直接登录本账号',
    oauthBind: '绑定',
    oauthBoundLabel: '已绑定',
    oauthBound: '已成功绑定 {provider}',
    oauthBindError: '绑定失败，请重试',
    noEmailHint: '绑定邮箱并设置密码后，即可用邮箱登录与找回账号',
    setPassword: '设置密码',
    setPasswordHint: '你当前通过第三方登录、尚未设置密码；设置后即可用「邮箱 + 密码」登录',
    subscriptionStatus: '权益状态',
    subscriptionNone: '当前无有效权益',
    subscriptionTrial: '试用中 · 剩余 {days} 天',
    subscriptionActive: 'Pro 会员 · 至 {date}',
    subscriptionExpired: 'Pro 会员已于 {date} 结束',
    subscribeNow: '开通 Pro 会员',
    hero: {
      daysLeft: '剩余 {days} 天',
      expiresAt: '至 {date} 到期',
      daysLeftLabel: '剩余天数',
      expiresAtLabel: '到期时间',
      daysUnit: '天'
    },
    inviteCode: '我的邀请码',
    inviteLink: '邀请链接',
    inviteHint: '好友通过你的邀请码注册或订阅，双方都有好礼',
    invitesEmpty: '暂时无法获取邀请码，请稍后再试',
    copyInviteLink: '复制邀请链接',
    copied: '已复制',
    memberBadge: {
      pro: 'PRO',
      trial: '试用'
    },
    rewards: {
      title: '邀请流水',
      total: '累计获得 {days} 天',
      empty: '暂无邀请流水。邀请好友注册你可得奖励天数，好友首次开通 Pro 会员你再得对应时长奖励',
      loadMore: '加载更多',
      retracted: '已收回',
      subscribeNode: '首次订阅',
      registerNode: '注册'
    },
    recordsTitle: '权益流水',
    recordsEmpty: '暂无权益记录',
    recordTrial: '试用',
    recordSubscribe: '订阅',
    recordInviteReward: '邀请奖励',
    recordRedeem: '兑换码',
    recordAdjust: '人工调整',
    recordContribute: '解说奖励',
    recordRecommend: '推荐奖励',
    recordAdvice: '反馈补偿',
    recordDays: '延长 {days} 天',
    recordDaysDeduct: '扣减 {days} 天',
    recordAt: '至 {date}',
    ordersTitle: '订单记录',
    ordersEmpty: '暂无订单',
    ordersEmptyDesc: '开通 Pro 会员后，支付与退款记录都会在这里',
    ordersLoadMore: '加载更多订单',
    // 价格折扣项展示名（后端只发 key，label 前端三语渲染；互斥取最优至多一项生效）
    discount: {
      activity: '活动折扣',
      inviteFirst: '受邀首单折扣',
      firstOrder: '首订折扣',
      renewal: '续订折扣',
      adminAdjust: '后台改价'
    },
    plan: {
      monthly: '月度',
      quarterly: '季度',
      yearly: '年度'
    },
    order: {
      pending: '待支付',
      paid: '已支付',
      refundRequested: '退款处理中',
      refunded: '已退款',
      closed: '已取消',
      payNow: '继续支付',
      cancel: '取消订单',
      cancelConfirm: '确定取消该待支付订单吗？',
      cancelled: '订单已取消',
      paySucceeded: '支付成功，权益已生效',
      payPending: '订单已创建，请在订单内完成支付',
      pendingHint: '待支付订单有效期为 {minutes} 分钟，超时自动关闭',
      pendingExpires: '待支付 · 剩 {minutes} 分钟后自动关闭',
      emptyCta: '去开通 Pro 会员',
      applyRefund: '申请退款',
      refundPrompt: '请填写退款原因（选填，仅用于改进）：',
      refundSubmitted: '退款申请已提交',
      cancelManual: '用户主动取消',
      cancelTimeout: '超时未支付自动关闭',
      cancelSuperseded: '被新订单取代'
    },
    channel: {
      wechat: '微信支付',
      alipay: '支付宝',
      mock: '模拟支付'
    },
    cancelDialog: {
      title: '取消订单',
      confirm: '确定取消该待支付订单？取消后如需开通请重新下单。'
    },
    refundDialog: {
      title: '申请退款',
      note: '本产品为虚拟数字商品，退款将按已使用天数比例清算；已使用天数含开通当天，无全额退款。',
      breakdownTitle: '退款明细',
      paidAt: '开通日期',
      used: '已使用（含今天）',
      remaining: '剩余天数',
      total: '套餐天数',
      paidAmount: '实付金额',
      refundAmount: '本次退款',
      refundAmountTip: '退款金额 = 实付 × 剩余天数 ÷ 套餐天数（向下取分）',
      confirmNote: '确认退款后立即原路退回，权益将按剩余天数收回；邀请人奖励将全额收回，首单资格不返还。',
      discountLossNote: '退款成功后，本次已使用的优惠（如首订 / 受邀首单折扣）将不返还，后续订阅可能不再享受首订优惠。',
      agreePolicy: '我已阅读并同意',
      policy: '《退款政策》',
      agreeRequired: '请先勾选已阅读《退款政策》',
      reason: '如果您对产品有任何不满意，可以告诉我们，方便我们做得更好（选填）',
      submit: '确认退款',
      notEligible: '该订单已无可退金额'
    },
    orderDetail: {
      title: '订单详情',
      orderNo: '订单号 {no}',
      amount: '金额明细',
      original: '套餐原价',
      discount: '折扣优惠',
      channel: '支付方式',
      inviter: '邀请人：{name}',
      payable: '实付金额',
      timeline: '处理进度',
      created: '下单时间',
      paidAt: '支付完成',
      entitledUntil: '权益至',
      refundRequestedAt: '提交退款',
      refundedAt: '退款完成',
      closedAt: '订单关闭',
      refundReason: '退款原因',
      refundReview: '审核意见',
      refundPolicy: '退款政策',
      resubscribe: '再次订阅'
    }
  },

  subscribe: {
    hero: {
      title: 'Pro 会员',
      subtitle: '免费档提供第三方赛事导航；开通 Pro 会员解锁国内外赛事导航与完整剧透防护。新用户注册即享 {days} 天 Pro 试用。',
      ctaLogin: '登录'
    },
    chip: {
      invited: '受邀首单 {off}',
      firstOrder: '首次开通 {off}',
      renewal: '订阅期内续费 {off}',
      default: '订阅解锁全部防护'
    },
    campaign: {
      tag: '限时活动',
      countdown: '距结束',
      days: '天',
      deadline: '截至',
      hint: '本期为限时活动价，续费将按续订优惠计算'
    },
    scenes: {
      title: '看回放，不被告剧透',
      subtitle: '隐分宝在视频页面实时遮挡比分与关键事件，安心回看每一场',
      demo: {
        without: '未开启防护',
        with: 'Pro 会员已开启',
        teams: '阿森纳 vs 切尔西 · 英超第 30 轮',
        score: '2 - 1',
        scorer: '萨卡 78 分钟破门',
        hidden: '已隐藏'
      },
      s1: {
        title: '回放防剧透',
        desc: '回看比赛时自动遮挡比分、进球队与关键事件，看完再揭晓'
      },
      s2: {
        title: '精彩瞬间回看',
        desc: '进球、红牌、点球等关键时刻逐段回看，不被结果抢先剧透'
      },
      s3: {
        title: '赛季档案收藏',
        desc: '整场比赛收藏进档案，数据永不失效，随时回看'
      }
    },
    badge: {
      activity: '限时活动',
      inviteFirst: '受邀首单',
      firstOrder: '首订优惠',
      renewal: '续费优惠',
      noDiscount: '不使用优惠'
    },
    offZhe: '{value} 折',
    offPercent: '{percent}% off',
    status: {
      trial: '试用中 · 剩余 {days} 天',
      subscribed: 'Pro 会员 · 至 {date}',
      expired: 'Pro 会员已于 {date} 结束',
      trialExpired: '试用已于 {date} 结束',
      none: '订阅解锁完整防护',
      refresh: '刷新权益状态'
    },
    compare: {
      title: '免费与 Pro 会员',
      subtitle: '注册即可使用免费档（第三方赛事导航）；开通 Pro 会员解锁国内外赛事导航与完整剧透防护',
      headerFree: '免费',
      headerSub: 'Pro',
      infoLabel: '功能说明',
      rows: [
        {
          label: '足球第三方赛事导航',
          group: 'free',
          free: true,
          sub: true,
          info: '汇集直播吧、咪咕视频、爱奇艺、央视体育、央视频等第三方平台的足球回放与集锦入口，一键前往对应平台观赛。'
        },
        {
          label: '篮球第三方赛事导航',
          group: 'free',
          free: true,
          sub: true,
          info: '汇集直播吧、咪咕视频、爱奇艺、央视体育、央视频等第三方平台的篮球回放与集锦入口，一键前往对应平台观赛。'
        },
        {
          label: '渐进式导航展示',
          group: 'free',
          free: true,
          sub: true,
          info: '针对可能进入加时赛或点球大战的足球、篮球等赛事，加时与点球视频默认折叠。先看完整个常规赛，再自行决定是否展开加时或点球，最大程度避免提前剧透。'
        },
        {
          label: '解说员标注',
          group: 'free',
          free: true,
          sub: true,
          info: '为各个来源网站的回放资源标注解说员信息，方便选择喜欢的解说员来观看赛事。'
        },
        {
          label: '赛事预告',
          group: 'free',
          free: true,
          sub: true,
          info: '未来两周的赛程时间线，提前看到有哪些比赛、什么时候开赛、对阵双方是谁，方便安排观赛计划。'
        },
        {
          label: '足球国内外赛事导航',
          group: 'pro',
          free: false,
          sub: true,
          info: '汇集五大联赛、欧冠、世界杯、欧洲杯等国际顶级赛事，也覆盖中超、中甲、中乙以及苏超、村超等全民赛事。每日更新已完赛赛事的回放与集锦，一键即可观赛。'
        },
        {
          label: '篮球国内外赛事导航',
          group: 'pro',
          free: false,
          sub: true,
          info: '覆盖 NBA、CBA 等篮球重大赛事。每日更新已完赛赛事的回放与集锦，一键即可观赛。'
        },
        {
          label: '剧透信息隐藏',
          group: 'pro',
          free: false,
          sub: true,
          core: true,
          info: '插件的核心功能：隐藏页面下的标题、比分、封面、介绍、评论等各种剧透信息，保证观看回放时不被剧透打扰。'
        },
        {
          label: '加载遮罩层',
          group: 'pro',
          free: false,
          sub: true,
          info: '网页加载开始时显示遮罩层，防止网页加载初期比分与剧透信息瞬间闪现。'
        },
        {
          label: '视频开头遮挡面板',
          group: 'pro',
          free: false,
          sub: true,
          info: '观看集锦或回放时，防止视频开头出现比分剧透。可提前设置遮挡面板，按设定秒数盖住开头画面。'
        },
        {
          label: '进度条防护',
          group: 'pro',
          free: false,
          sub: true,
          info: '隐藏进度条与结束时间，避免通过进度与时长提前推断比赛结果。'
        },
        {
          label: '快进快退浮动按钮',
          group: 'pro',
          free: false,
          sub: true,
          info: '观看视频时显示快进快退浮动按钮，支持自定义步长，方便按自己的观看节奏控制进度。'
        },
        {
          label: '设置自动同步',
          group: 'pro',
          free: false,
          sub: true,
          info: '登录后自动同步设置与偏好，更换设备也能无缝续用，无需重新配置。'
        },
        {
          label: '全屏锁屏',
          group: 'pro',
          free: false,
          sub: true,
          info: '视频全屏播放时出现锁屏按钮，点击后锁定画面防误触；再点解锁，退出全屏自动解锁。'
        },
        {
          label: '收藏功能',
          group: 'pro',
          free: false,
          sub: true,
          info: '收藏整场比赛随时回看，足球与篮球通用；收藏数据服务端保存、永不过期，超出每日更新窗口的场次也能回查。'
        },
        {
          label: '关注（赛事 / 队伍）',
          group: 'pro',
          free: false,
          sub: true,
          info: '关注自己喜欢的赛事与球队，赛事页「关注」标签只展示关注对象的比赛，并可切换只看「我的球队」。与「收藏」相互独立：关注决定看到哪些比赛，收藏用于整场回看。'
        }
      ]
    },
    plans: {
      title: '选择 Pro 会员方案',
      subtitle: '一次开通，解锁全部防护能力。',
      bestValue: '最划算',
      days: '{days} 天权益',
      perMonth: '折合 ¥{price}/月',
      save: '较月付立省 ¥{amount}',
      originalPrice: '原价',
      guestNote: '未登录价格为按新用户资格的预估价，登录后以实际资格为准',
      subscribe: '开通 Pro 会员',
      renew: '续费 Pro 会员',
      processing: '处理中…'
    },
    order: {
      success: '开通成功！权益已延长 {days} 天，至 {date}',
      pending: '订单已创建（{orderNo}），请在个人中心完成支付'
    },
    resume: {
      pending: '你有一笔未完成的支付订单',
      continue: '继续支付',
      alreadyPaid: '该订单已支付成功，权益已生效',
      expired: '该笔待支付订单已超时或被新订单取代，请重新下单'
    },
    consent: {
      note: '点击即表示你已阅读并同意',
      terms: '《用户协议》',
      and: '与',
      refund: '《退款政策》',
      disclaimer: '本工具仅对受支持的视频页面提供本地遮挡，不保证所有页面与所有时刻的完整覆盖。'
    },
    notice: {
      title: '开通前请了解',
      items: [
        '支付成功后权益立即生效，按未使用时长顺延叠加。',
        '本产品为虚拟数字商品，不支持无理由全额退款；特殊情况可联系反馈，经核实后按已使用天数比例清算退款。',
        '本工具仅对受支持的视频页面提供本地遮挡，不保证所有页面、所有时刻的完整覆盖。',
        '试用、兑换码、邀请奖励、赠送获得的权益不参与退款。'
      ],
      gotIt: '知道了'
    },
    invite: {
      title: '邀请好友，双方都有好礼',
      subtitle: '好友通过你的邀请链接注册或开通，双方都能拿到实实在在的好处。',
      myCode: '我的邀请码',
      shareHint: '把邀请链接发给好友：好友点击链接后 24 小时内注册即与邀请人绑定，双方立即生效',
      copy: '复制链接',
      copied: '邀请链接已复制',
      invitedDesc: '邀请你开通 Pro 会员，首单立享 {off}',
      clear: '清除',
      clearHint: '清除后按非受邀价格显示；注册前清除不会被绑定邀请关系',
      stats: '已邀请 {count} 人 · 已累计获得 {days} 天',
      friendTitle: '给好友',
      friendRule1: '好友通过你的邀请码首次开通 Pro 会员，首单立享 {off}',
      meTitle: '给你自己',
      meRule1: '好友注册成功，你立即获得 +{days} 天',
      meRule2: '好友首次开通任意 Pro 方案，你再得该方案时长的 {percent}%（仅首次开通触发）',
      rulesLink: '查看完整邀请规则'
    },
    redeem: {
      title: '兑换码',
      subtitle: '有兑换码？输入即可兑换对应时长的 Pro 会员权益。每个账号限领一次。',
      placeholder: '输入兑换码',
      submit: '兑换',
      processing: '兑换中…',
      success: '兑换成功！权益已延长 {days} 天，至 {date}',
      codeRequired: '请输入兑换码'
    },
    faq: {
      title: '常见问题',
      items: [
        { q: '为什么不支持微信登录和微信支付？', a: '产品初次上线仅开放支付宝收单，暂未接入微信登录与微信支付。后续版本会完成微信登录与微信支付的接入，开放后会同步更新登录页与订阅页；当前可先使用支付宝完成支付。' },
        { q: '兑换码如何获取？', a: '兑换码主要来自微信公众号「膨胀的球」、官方反馈群，以及体验问题补偿与运营活动的发放。获取后在订阅页「兑换码」区域输入即可，每个兑换码仅可使用一次，兑换成功后权益时长立即顺延。公众号与反馈群二维码见「关于我们」页。' },
        { q: '好友退款后，我的邀请奖励会怎样？', a: '好友的首次订阅订单退款后，你因该好友获得的订阅奖励时长会全额收回，权益流水与邀请流水都会标记「已收回」并重新计算你的到期时间；好友注册时发放的注册奖励不收回。' },
        { q: '为什么没登录时看到的价格，登录后变了？', a: '未登录时套餐展示的是按新用户资格计算的预估价；登录后系统按你的真实资格（是否首次订阅、是否受邀、当期是否有活动）重新计价，因此可能更低，也可能回到原价。最终金额以收银台显示为准。' },
        { q: '在收银台改了优惠选择会怎样？', a: '收银台默认选中对你最优惠的一项，你可以换成其他折扣，也可以选择不使用优惠。选哪一项就按哪一项的金额实付，订单明细同样按所选记录；无论选哪一项，这笔订单都算你的首次订阅。' },
        { q: '试用和兑换码算首次订阅吗？', a: '不算。试用、兑换码、邀请奖励与运营赠送都不涉及实付出资，不会消耗首单资格；只有实际支付成功的订阅订单才算首次订阅。' },
        { q: '支付成功但会员没到账怎么办？', a: '支付结果由系统自动对账，收银台会在你付款后自动确认并延长权益，通常数秒内完成。若页面停留在确认状态，可点击「刷新状态」，或重新登录后到个人中心查看；仍未到账时请在浏览器扩展的「反馈」中提交订单号，我们核实后会处理。' },
        { q: '换电脑或重装浏览器，会员还在吗？', a: 'Pro 会员权益绑定账号而不是设备。在新浏览器安装扩展并登录同一账号，防护能力与剩余时长即恢复。只有试用资格按设备与身份双重校验，同一设备仅可领取一次。' },
        { q: '到期前续费会浪费剩余天数吗？', a: '不会。新增时长在当前到期时间之后顺延累加，提前续费不会清零；兑换码与邀请奖励也按同一规则叠加。你的到期时间可在个人中心与订阅页查看。' }
      ]
    },
    errors: {
      loadPlans: '套餐信息加载失败，请稍后重试',
      noChannel: '支付暂不可用，请稍后再试',
      generic: '操作失败，请稍后重试',
      copyFailed: '复制失败，请手动复制'
    },
    loading: '加载中…'
  },

  validation: {
    emailRequired: '请输入邮箱',
    emailMax: '邮箱长度不能超过100位',
    emailFormat: '邮箱格式不正确',
    passwordRequired: '请输入密码',
    passwordFormat: '密码需为8-20位，且包含大写字母、小写字母和数字',
    passwordLength: '长度需为8-20位',
    passwordLower: '需包含小写字母',
    passwordUpper: '需包含大写字母',
    passwordDigit: '需包含数字',
    passwordSpace: '不能包含空格',
    codeRequired: '请输入验证码',
    codeFormat: '验证码为6位数字',
    nameRequired: '请输入昵称',
    nameMax: '昵称长度不能超过30个字符'
  },

  install: {
    crumbs: '面包屑导航',
    crumbsHome: '安装',

    // 分端安装 tab（桌面 Chrome/Edge/Firefox/其他Chromium + 手机 Edge/Firefox + iOS 卡）
    // 每个端一步到底：安装 → 固定 → 进入管理控制台 → 观赛；配图约定见 docs/main/specs/assets.md
    tabs: {
      title: '安装隐分宝',
      subtitle: '选择你的设备与浏览器，跟着步骤装好并开始观赛',
      calloutBadge: '推荐桌面端',
      calloutTitle: '商店安装支持自动更新，最省心',
      groups: { desktop: '电脑端', mobile: '手机端', ios: 'iOS / iPadOS' },
      tabLabels: {
        chrome: 'Chrome',
        chromeManual: 'Chrome · 手动安装',
        edge: 'Edge',
        firefox: 'Firefox',
        chromium: '其他 Chromium',
        edgeMobile: 'Edge · 手机版',
        firefoxMobile: 'Firefox · 手机版'
      },
      platformBadges: {
        desktop: 'Windows / macOS / Linux',
        android: 'Android / HarmonyOS'
      },
      recommended: '推荐',
      methodBadges: { store: '商店安装', manual: '手动安装' },
      intro: {
        chrome: '支持商店安装和手动安装两种方式。推荐商店安装（支持自动更新，省心省力）；无法访问应用商店时，使用手动安装。',
        chromeManual: '适用于无法访问 Chrome 应用商店的情况。注意：手动安装的版本不会自动更新，建议定期关注官网获取最新版本。',
        edge: 'Edge 支持通过 Edge 加载项商店一键安装。',
        firefox: 'Firefox 支持通过 Firefox 附加组件商店一键安装。',
        chromium: '360 极速 / QQ / 搜狗 / 猎豹 / Opera / UC 等基于 Chromium 内核的浏览器，可参照 Chrome 手动安装方式加载 .crx。',
        edgeMobile: '移动端仅支持 Edge 与 Firefox 两款浏览器，且只支持商店安装，不支持手动安装。',
        firefoxMobile: '移动端仅支持 Edge 与 Firefox 两款浏览器，且只支持商店安装。部分应用商店搜索不到 Firefox，可用下方 APK 链接安装浏览器。'
      },
      steps: {
        chrome: [
          '打开 Chrome 浏览器，访问 Chrome 网上应用店',
          '在搜索框中输入「隐分宝」进行搜索',
          '点击页面右侧的「添加到 Chrome」',
          '在弹出的确认窗口中，点击「添加扩展程序」',
          '安装完成后，Chrome 工具栏右侧会出现隐分宝图标',
          '如果图标被隐藏在扩展菜单中，点开工具栏右侧的拼图图标，在列表中找到隐分宝，点击图钉按钮将其固定到工具栏（推荐），方便后续使用',
          '点击隐分宝图标，弹出小窗后点击「进入管理控制台」',
          '进入控制台后，即可在赛事导航中选比赛前往观赛，也可以点击左侧菜单栏自定义观赛设置'
        ],
        chromeManual: [
          '打开隐分宝官网手动安装指南页，下载 .crx 安装包（见下方入口）',
          '点击浏览器菜单图标，找到「扩展」，打开管理扩展程序页面',
          '打开页面右上角的「开发者模式」开关',
          '将下载好的 .crx 文件从文件夹中直接拖拽到扩展程序页面中',
          '在弹出的提示窗口中，点击「添加扩展程序」',
          '安装完成后，点击工具栏拼图图标，找到隐分宝并点击图钉固定到工具栏（推荐）',
          '点击隐分宝图标，弹出小窗后点击「进入管理控制台」',
          '进入控制台后，即可在赛事导航中选比赛前往观赛，也可以点击左侧菜单栏自定义观赛设置'
        ],
        edge: [
          '打开 Edge 浏览器，访问 Edge 加载项商店',
          '在搜索框中输入「隐分宝」进行搜索',
          '点击页面上的「获取」按钮',
          '在弹出的提示窗口中，点击「添加扩展」',
          '安装完成后，Edge 工具栏右侧会出现隐分宝图标',
          '点击工具栏右侧的拼图图标，在扩展列表中找到隐分宝，点击图钉按钮固定到工具栏（推荐）',
          '点击隐分宝图标，弹出小窗后点击「进入管理控制台」',
          '进入控制台后，即可在赛事导航中选比赛前往观赛，也可以点击左侧菜单栏自定义观赛设置'
        ],
        firefox: [
          '打开 Firefox 浏览器的扩展和主题页面',
          '在搜索框中输入「隐分宝」进行搜索',
          '点击页面上的「添加到 Firefox」按钮',
          '在弹出的提示窗口中，点击「添加」',
          '安装完成后，勾选「将扩展固定到工具栏」选项',
          '点击隐分宝图标，弹出小窗后点击「进入管理控制台」',
          '进入控制台后，即可在赛事导航中选比赛前往观赛，也可以点击左侧菜单栏自定义观赛设置'
        ],
        chromium: [],
        edgeMobile: [
          '在各大应用商店搜索并下载安装 Edge 浏览器',
          '打开 Edge 浏览器，进入首页点击菜单栏图标',
          '在菜单界面点击「扩展」，打开扩展管理界面',
          '搜索「隐分宝」，在搜索结果中找到隐分宝，并点击「获取」',
          '弹出提示界面后，点击「添加」，此时会显示已安装',
          '回到首页，继续点击菜单栏 → 「扩展」，会发现多了一个隐分宝',
          '点击隐分宝，在弹出界面点击「进入控制台」，即可正常观赛',
          '也可以点击左侧菜单栏，自定义观赛设置'
        ],
        firefoxMobile: [
          '在应用商店搜索下载安装 Firefox 浏览器；如无法访问 Google Play，可通过下方 APK 链接安装',
          '打开 Firefox，进入首页点击右上角菜单图标',
          '在展开的菜单中选择「扩展」',
          '在扩展列表界面下拉到最底部，点击「寻找更多扩展」，跳转到扩展商店',
          '在商店搜索框中输入「隐分宝」进行搜索',
          '打开详情页后点击「添加到 Firefox」，对弹窗点击「添加」，显示安装成功',
          '特别注意：安装成功后需先打开任意一个网页，再点击右上角菜单 → 「扩展」，此时列表中已多出隐分宝',
          '点击隐分宝，在弹出界面中点击「进入管理控制台」，即可正常观赛；也可点击左侧菜单栏自定义观赛设置'
        ]
      },
      links: {
        manualGuideText: '前往手动安装指南',
        manualGuideHint: '支持浏览器清单 + 开发者模式拖拽安装步骤',
        apkText: 'Firefox APK 下载（Mozilla 官方站点）',
        apkHref: 'https://ftp.mozilla.org/pub/fenix/releases/152.0.5/android/fenix-152.0.5-android-arm64-v8a/'
      },
      chromiumCta: '查看手动安装指南',
      doneText: '至此所有安装步骤已完成，可以放心使用了',
      noticeTitle: '友情提示',
      notice: '只对隐分宝控制台中打开的首个网页可以实现剧透遮挡效果，对其他非隐分宝来源打开的任意网站，无法实现剧透隐藏效果。',
      ios: {
        title: 'iOS / iPadOS 暂不支持',
        reason: 'iOS 受 Apple 系统限制，浏览器无法加载扩展。',
        note: '后续若 iOS 端方案成熟，我们会第一时间在官网更新。'
      },
      helpLine: '需要帮助？联系 {email}'
    },

    store: {
      title: '商店安装',
      subtitle: '一键安装到你的浏览器，自动更新，最省心',
      detectedBadge: '推荐',
      detectedCta: '前往 {browser} 商店安装',
      fallbackHint: '不是 {browser}？选择其他浏览器',
      fallbackLabel: '选择浏览器',
      backToInstall: '返回安装方式',

      methodStore: '应用商店一键安装',

      browsers: {
        chrome: 'Chrome',
        edge: 'Edge',
        firefox: 'Firefox'
      },
      platforms: {
        desktop: '桌面端',
        android: 'Android',
        ios: 'iOS',
        harmonyos: 'HarmonyOS'
      },
      unavailable: '暂不支持',
      useDesktop: '请使用桌面端浏览器（Chrome / Edge / Firefox 任一均可）获得完整体验。',
      backToStore: '返回安装指南',

      chrome: {
        desktop: {
          title: 'Chrome 桌面端安装',
          subtitle: 'Windows / macOS / Linux',
          storeSteps: [
            '打开 Chrome 浏览器',
            '前往 Chrome 网上应用店',
            '搜索「隐分宝」',
            '点击「添加到 Chrome」',
            '在弹出窗口中点击「添加扩展程序」，并勾选授予所需的访问权限',
            '安装完成后，右上角扩展栏显示隐分宝图标；建议固定到工具栏方便快速开关',
            '点击隐分宝图标，弹出小窗后点击「进入管理控制台」',
            '在赛事导航中选比赛前往观赛，也可以点击左侧菜单栏自定义观赛设置'
          ]
        },
        android: {
          title: 'Chrome · Android',
          unavailableReason: 'Chrome 浏览器目前不支持 Android 端扩展安装。建议改用 Edge 或 Firefox 浏览器。'
        },
        ios: {
          title: 'Chrome · iOS',
          unavailableReason: 'Chrome 浏览器目前不支持 iOS 端扩展安装。'
        },
        harmonyos: {
          title: 'Chrome · HarmonyOS',
          unavailableReason: 'Chrome 浏览器目前不支持 HarmonyOS 端扩展安装。建议改用 Edge 或 Firefox 浏览器。'
        }
      },

      edge: {
        desktop: {
          title: 'Edge 桌面端安装',
          subtitle: 'Windows / macOS / Linux',
          storeSteps: [
            '打开 Edge 浏览器',
            '前往 Edge 加载项商店',
            '搜索「隐分宝」',
            '点击「获取」',
            '在弹出窗口中点击「添加扩展程序」，并勾选授予所需的访问权限',
            '安装完成后，建议把扩展固定到工具栏方便快速开关',
            '点击隐分宝图标，弹出小窗后点击「进入管理控制台」',
            '在赛事导航中选比赛前往观赛，也可以点击左侧菜单栏自定义观赛设置'
          ]
        },
        android: {
          title: 'Edge · Android',
          storeSteps: [
            '在手机上安装 Edge 浏览器（各大应用商店）',
            '打开 Edge，进入首页点击菜单栏图标',
            '在菜单界面点击「扩展」，打开扩展管理界面',
            '搜索「隐分宝」，点击「获取」',
            '弹出提示后点击「添加」，显示已安装',
            '回到首页打开菜单 → 「扩展」，点击隐分宝',
            '在弹出界面点击「进入控制台」，即可正常观赛；也可点击左侧菜单栏自定义观赛设置'
          ]
        },
        ios: {
          title: 'Edge · iOS',
          unavailableReason: 'Edge 浏览器目前不支持 iOS 端扩展安装。'
        },
        harmonyos: {
          title: 'Edge · HarmonyOS',
          storeSteps: [
            '在手机上安装 Edge 浏览器（各大应用商店）',
            '打开 Edge，进入首页点击菜单栏图标',
            '在菜单界面点击「扩展」，打开扩展管理界面',
            '搜索「隐分宝」，点击「获取」',
            '弹出提示后点击「添加」，显示已安装',
            '回到首页打开菜单 → 「扩展」，点击隐分宝',
            '在弹出界面点击「进入控制台」，即可正常观赛；也可点击左侧菜单栏自定义观赛设置'
          ]
        }
      },

      firefox: {
        desktop: {
          title: 'Firefox 桌面端安装',
          subtitle: 'Windows / macOS / Linux',
          storeSteps: [
            '打开 Firefox 浏览器',
            '前往 Firefox 附加组件商店',
            '搜索「隐分宝」',
            '点击「添加到 Firefox」',
            '在弹出窗口中点击「添加」，并勾选授予所需的访问权限',
            '安装完成后，建议把扩展固定到工具栏方便快速开关',
            '点击隐分宝图标，弹出小窗后点击「进入管理控制台」',
            '在赛事导航中选比赛前往观赛，也可以点击左侧菜单栏自定义观赛设置'
          ]
        },
        android: {
          title: 'Firefox · Android',
          storeSteps: [
            '在手机上安装 Firefox 浏览器（应用商店搜索，或通过 Mozilla 官方站点下载 APK）',
            '打开 Firefox，点击首页右上角菜单图标',
            '在展开的菜单中选择「扩展」',
            '下拉到最底部，点击「寻找更多扩展」，跳转到扩展商店',
            '搜索「隐分宝」，打开详情页后点击「添加到 Firefox」',
            '弹出窗口点击「添加」，显示安装成功',
            '注意：需先打开任意一个网页，再点击右上角菜单 → 「扩展」，列表中已多出隐分宝',
            '点击隐分宝，在弹出界面点击「进入管理控制台」，即可正常观赛；也可点击左侧菜单栏自定义观赛设置'
          ]
        },
        ios: {
          title: 'Firefox · iOS',
          unavailableReason: 'Firefox 浏览器目前不支持 iOS 端扩展安装。'
        },
        harmonyos: {
          title: 'Firefox · HarmonyOS',
          storeSteps: [
            '在手机上安装 Firefox 浏览器（应用商店搜索，或通过 Mozilla 官方站点下载 APK）',
            '打开 Firefox，点击首页右上角菜单图标',
            '在展开的菜单中选择「扩展」',
            '下拉到最底部，点击「寻找更多扩展」，跳转到扩展商店',
            '搜索「隐分宝」，打开详情页后点击「添加到 Firefox」',
            '弹出窗口点击「添加」，显示安装成功',
            '注意：需先打开任意一个网页，再点击右上角菜单 → 「扩展」，列表中已多出隐分宝',
            '点击隐分宝，在弹出界面点击「进入管理控制台」，即可正常观赛；也可点击左侧菜单栏自定义观赛设置'
          ]
        }
      }
    },

    manual: {
      title: '手动安装 .crx',
      subtitle: '适用于所有基于 Chromium 内核的浏览器，包括未上架商店的国产浏览器',
      platformSupport: {
        title: '平台支持说明',
        items: [
          {
            mark: '✓',
            status: 'recommended',
            name: '桌面端',
            hint: '推荐。Windows / macOS 全支持，能获得完整体验。'
          },
          {
            mark: '△',
            status: 'partial',
            name: 'Android',
            hint: '部分支持。请使用支持加载 .crx 的浏览器（如 弧猴浏览器、Kiwi Browser 等）。'
          },
          {
            mark: '✗',
            status: 'unsupported',
            name: 'iOS',
            hint: '不支持。受 Apple 限制，浏览器无法正常安装扩展。'
          }
        ]
      },
      supportedTitle: '支持的浏览器',
      supportedBrowsers: [
        'Google Chrome',
        '360 极速浏览器',
        'QQ 浏览器',
        '搜狗高速浏览器',
        '360 浏览器',
        '猎豹浏览器',
        'Opera',
        'UC 浏览器'
      ],
      stepsTitle: '安装步骤',
      steps: [
        '下载 .crx 安装包到本地',
        '点击浏览器菜单图标，找到「扩展 / 插件管理」页面（一般在浏览器「设置 / 工具 / 扩展」里）',
        '打开页面右上角的「开发者模式」开关',
        '将下载好的 .crx 文件从文件夹中直接拖拽到扩展程序页面中',
        '在弹出的提示窗口中，点击「添加 / 安装」，并勾选授予所需的访问权限',
        '安装完成后，建议把扩展固定到工具栏，方便后续一键开关'
      ],
      downloadCta: '下载 .crx 安装包',
      backToInstall: '返回安装指南',
      supportedNote: '仅支持桌面端浏览器（Windows / macOS）',
      helpLine: '需要帮助？联系 {email}'
    }
  },

  download: {
    title: '下载隐分宝',
    subtitle: '已为您自动识别浏览器，点击下方按钮下载安装包',
    detectingBrowser: '正在识别浏览器...',
    directDownload: '直接下载',
    fallbackHint: '如未自动识别，请手动选择浏览器',
    viewOnStore: '前往商店'
  },

  about: {
    title: '关于隐分宝',
    intro: '@:product.aboutIntro',
    capabilitiesTitle: '核心能力',
    sitesTitle: '支持站点',
    sitesHint: '已支持 {count} 个主流体育视频网站',
    communityTitle: '公众号与反馈群',
    communityHint: '关注公众号获取更新动态，加入反馈群提交建议',
    wechatGzh: {
      title: '微信公众号（膨胀的球）',
      hint: '微信公众号搜索「膨胀的球」即可关注'
    },
    wechatGroup: {
      title: '微信反馈交流群',
      hint: '扫描二维码加入用户反馈与交流群'
    },
    authorTitle: '关于作者',
    authorContent: '由 膨胀（SwellMan）独立开发与维护。从最初为了自己不被回放剧透打扰的小工具，慢慢长成了支持三大浏览器、覆盖十多个主流体育视频网站的玩家必备。期待它能帮你找回第一次看球时的那份心跳。',
    contactTitle: '联系方式',
    contactEmailLabel: '反馈邮箱',
    legalTitle: '法律协议',
    legalLinks: {
      privacy: '隐私政策',
      terms: '用户协议',
    }
  },

  // 支持站点名称（Home / About 共用；扩展端也按官方名展示，见 replay_shield sites.json）
  sites: {
    migu: { name: '咪咕视频' },
    iqiyi: { name: '爱奇艺' },
    bilibili: { name: '哔哩哔哩' },
    cctv: { name: '央视网' },
    yangshipin: { name: '央视频' },
    tencent: { name: '腾讯视频' },
    douyin: { name: '抖音' },
    weibo: { name: '微博' },
    xiaohongshu: { name: '小红书' }
  },

  privacy: {
    title: '隐私政策',
    subtitle: '我们对您隐私的承诺',
    intro: '我们尊重并保护每一位用户的隐私。本政策以清晰易懂的方式，向您说明我们的产品会收集哪些信息、为什么收集、如何使用、如何保护，以及您对自己的信息享有哪些权利。',
    principlesTitle: '核心原则',
    principles: [
      {
        title: '数据本地优先',
        desc: '产品的核心功能——识别与隐藏剧透信息——全部在您的浏览器本地完成，浏览内容不会上传到我们的服务器。'
      },
      {
        title: '不追踪',
        desc: '我们不追踪您的浏览历史，不收集您的浏览行为，不构建任何形式的用户画像。'
      },
      {
        title: '零广告',
        desc: '产品无广告位、无推广合作、无第三方追踪脚本；订阅仅用于支持持续开发。'
      },
      {
        title: '最小必要',
        desc: '我们只申请实现核心功能所必需的浏览器权限；任何权限的变更都会同步更新本政策。'
      }
    ],
    sections: {
      scope: {
        title: '一、本政策适用范围',
        content: '本政策适用于"Replay Shield"（中文名称"隐分宝"）浏览器扩展及本网站 woofootball.site。下文中"产品"或"我们"指代上述扩展与网站的运营方。本政策不适用于您通过我们的扩展所访问的任何第三方网站——那些网站各自拥有独立的隐私政策，请参阅其各自的说明。'
      },
      whatWeCollect: {
        title: '二、我们收集哪些信息',
        items: [
          '您主动提交的信息：当您通过"意见反馈"等渠道联系我们时，我们会收到您选择填写的内容（例如邮箱、问题描述、附图等）。',
          '扩展偏好设置：您选择的语言、主题、隐藏规则开关等偏好保存在您的浏览器本地，仅在本地用于产品运行。',
          '必要的安全日志：当我们提供的接口收到请求时，会按照业界通行做法记录必要的信息（例如请求时间、必要的网络标识等），用于安全审计、故障排查与防滥用。',
          '支付与订单信息：当您开通 Pro 会员时，我们会处理完成订阅订单所必需的信息（例如订单号、套餐与金额、支付渠道返回的交易凭证、退款原因与审核记录），仅用于订单处理、财务核对、退款审核与客户服务。'
        ]
      },
      permissions: {
        title: '三、浏览器权限说明',
        intro: '为实现核心功能，扩展需要向浏览器申请若干权限。下方我们以"用途"而非"权限名称"来逐项说明——这样更便于您理解我们能用这些权限做什么、不能做什么。',
        items: [
          '访问当前页面内容：用于在您访问受支持的体育视频页面时，根据您设定的规则隐藏剧透元素。该能力仅在您主动操作扩展或命中受支持页面时使用。',
          '本地存储偏好：将您选择的语言、主题、规则开关等保存在浏览器本地，您可以随时在扩展设置中查看与清除。',
          '向受支持的体育视频站点注入样式规则：仅在我们维护的一份站点清单上应用隐藏规则。当前清单可在扩展设置中查看，并随产品迭代更新。',
          '接收您的主动指令：响应您点击扩展图标、切换设置、提交反馈等操作。'
        ]
      },
      dataRetention: {
        title: '四、数据保留与删除',
        items: [
          '本地偏好：保存在您的浏览器本地，直至您卸载扩展、清除扩展数据或手动重置。',
          '反馈信息：仅在处理您所提问题的合理必要期限内保留，问题处理完毕后即行删除或匿名化。',
          '安全日志：仅在保障服务安全、排查故障、应对安全事件所必要的期限内保留，具体期限遵循行业通行做法与适用法律。',
          '如您希望我们删除您主动提交的信息，请通过本政策末尾的联系方式与我们联系。'
        ]
      },
      userRights: {
        title: '五、您对个人信息的权利',
        intro: '我们尊重您对个人信息享有的权利。您可以：',
        items: [
          '查询、复制我们持有的与您有关的个人信息',
          '更正或补充不准确、不完整的信息',
          '在符合法律规定的条件下，要求我们删除相关信息',
          '撤回您此前作出的同意',
          '通过本政策末尾的联系方式向我们提出疑问、投诉或举报'
        ],
        closing: '由于本产品不设账户体系，绝大部分偏好信息保存在您的本地设备，您可以直接通过扩展设置或浏览器的数据管理功能行使上述权利。对于需要我们协助处理的部分，请通过下方联系方式与我们联系，我们将在合理期限内响应。'
      },
      security: {
        title: '六、我们如何保护您的信息',
        items: [
          '我们使用业界通行的加密传输与签名机制保护我们与您浏览器之间的通信',
          '本地数据保存在浏览器提供的、与普通网页隔离的区域',
          '我们持续关注行业安全实践，并按需更新我们的防护措施',
          '但请理解：没有任何系统能够保证绝对安全。如发生安全事件，我们将依法及时告知您'
        ]
      },
      crossBorder: {
        title: '七、跨境传输',
        content: '我们的服务基础设施部署在中华人民共和国境内。默认情况下，您的信息均在境内处理；如您从境外使用产品，必要的网络通信将按照适用法律进行。我们不会主动将您的个人信息向境外提供。'
      },
      children: {
        title: '八、儿童隐私',
        content: '本产品不针对未满十四周岁的未成年人单独设计。如未成年人使用本产品，应在其监护人同意的前提下进行。我们不会主动收集未成年人的个人信息；如您作为监护人发现未成年人未经同意提交了个人信息，请通过本政策末尾的联系方式与我们联系，我们将协助处理。'
      },
      thirdParty: {
        title: '九、第三方链接与服务',
        content: '我们的产品可能包含前往第三方浏览器应用商店、其他第三方网站的链接，或在受支持的第三方体育视频站点上运行。这些第三方各自拥有独立的隐私政策与用户协议，我们无法控制其做法。建议您在使用前查阅相关第三方的政策。'
      },
      updates: {
        title: '十、本政策的更新',
        content: '我们可能根据产品迭代、法律法规变化等情况更新本政策。对于重大变更，我们会通过扩展内的"版本更新"页面与官网公告提前告知。变更生效后继续使用本产品，即视为您接受变更后的政策。'
      },
      contact: {
        title: '十一、联系我们',
        content: '如您对本政策、对您个人信息的处理有任何疑问，或希望行使本政策赋予您的权利，请通过以下邮箱与我们联系：'
      }
    }
  },

  terms: {
    title: '用户协议',
    subtitle: '使用本产品前请阅读',
    intro: '欢迎使用"Replay Shield"（中文名称"隐分宝"）及其官方网站（下文统称"产品"）。本协议是您与运营方之间就使用本产品所订立的协议。请仔细阅读本协议全部条款；使用本产品即视为您已阅读、理解并同意本协议。',
    sections: {
      service: {
        title: '一、服务内容',
        content: '本产品是一款浏览器扩展，为观看体育比赛回放或精彩集锦的用户提供比分、标题、封面、评论等剧透信息的本地隐藏功能；同时本网站为上述功能提供介绍、安装与下载入口。服务采用免费 + 订阅制（基础功能免费使用，Pro 会员为付费订阅），新用户注册可享 Pro 试用，试用期内功能不受限制。'
      },
      subscriptionPay: {
        title: '二、订阅、支付与退款',
        intro: '本节说明 Pro 会员订阅服务相关的计价、支付、权益入账与退款规则。《退款政策》为本节的细化约定，二者不一致时以《退款政策》为准。',
        items: [
          '定价与费用：套餐价格以订阅页展示为准；活动期间按折扣价计算，活动结束后恢复原价。用户通过邀请链接注册并绑定的好友，首次开通时享受受邀首单折扣；下单时如有多个候选折扣，可在收银台自行选择（默认按最优计算）。',
          '支付渠道：支付由第三方渠道（支付宝等）提供，并可能在支付环节收取少量手续费。',
          '权益入账：权益在支付成功后按"未使用时长顺延"方式叠加计算（即总有效期 = 当前有效期与当前时间之较大者 + 本次时长），支付成功前不发放权益。',
          '退款规则：本产品为虚拟数字商品，用户侧默认不提供主动退款入口；因产品问题等特殊情况确需退款时，经运营方核实开放退款权限后，按已使用天数比例清算退款（已使用天数含开通当天，无 100% 退款）；退款成功后对应邀请奖励全额收回、首单资格不返还。试用、兑换码、邀请奖励、赠送获得的权益不参与退款。具体约定见《退款政策》。',
          '服务范围与限制：本产品按"现状"提供，仅对受支持页面的本地遮挡负责，不保证所有页面、所有时刻的完整覆盖；因第三方站点改版、页面结构变化等导致的隐藏失效，运营方不承担超出实付金额的责任。',
          '服务终止：如运营方停止提供订阅服务，对用户尚未消耗的付费时长将按比例退还未消耗金额。'
        ]
      },
      license: {
        title: '三、使用许可',
        content: '运营方授予您非独占、不可转让、可撤销的使用本产品的权利。您可在符合所在国家/地区法律法规的前提下，于个人设备上安装并使用本扩展。运营方保留在任何时候暂停或终止部分或全部服务的权利。'
      },
      intellectualProperty: {
        title: '四、知识产权',
        items: [
          '本产品的名称、Logo、界面设计、图标、文案等受知识产权保护，未经运营方书面授权不得使用',
          '本产品中使用的开源组件及其许可证信息，详见扩展内的"关于"页面',
          '本产品运行所涉及的第三方站点的名称、Logo、域名等，为其各自所有者的商标；运营方与之不存在代言、许可或合作关系'
        ]
      },
      restrictions: {
        title: '五、使用限制',
        items: [
          '不得对本产品进行反向工程、反编译、反汇编或试图提取源代码',
          '不得对本产品进行修改、二次开发、再分发或商业转售',
          '不得利用本产品从事任何违反所在地法律法规的活动',
          '不得利用本产品绕过任何第三方站点的访问控制、付费墙或订阅验证',
          '不得利用本产品对任何第三方进行骚扰、欺诈、传播违法或不良信息'
        ]
      },
      specificFeatures: {
        title: '六、特定功能使用声明',
        intro: '本节就产品中的核心隐藏功能向您作进一步说明，以便您了解其法律性质与责任边界。',
        items: [
          '本产品对受支持站点上的剧透元素所进行的处理，全部在您本地的浏览器中完成。',
          '本产品不复制、不传播、不再分发任何第三方站点的内容。',
          '本产品不绕过付费墙、不获取付费内容、不规避订阅验证。',
          '本产品不会修改第三方站点的服务端数据。',
          '本产品与本协议第三条所列第三方站点之间不存在任何官方合作关系。',
          '由于第三方站点的页面结构持续迭代，本产品的隐藏规则可能因站点改版而局部失效；运营方将持续适配，但不承诺任何时刻下规则的实时有效性。',
          '在使用本产品的隐藏功能前，请确认您所在司法辖区的法律以及目标站点的用户协议是否允许此类本地化处理；如有任何疑虑，请停止使用相关功能。',
          '运营方对您使用本产品隐藏功能所引发的任何第三方纠纷、账号封禁或合规问题不承担任何责任；相关合规风险由您本人承担。'
        ]
      },
      disclaimer: {
        title: '七、免责声明',
        items: [
          '本产品按"现状"提供，运营方不对特定适用性、稳定性、不中断性作任何明示或暗示的担保',
          '因第三方站点页面改版导致部分隐藏规则失效的情况，运营方不承担责任',
          '因您设备环境、网络状况、浏览器版本差异导致的功能异常，运营方不承担责任',
          '运营方不对您因使用本产品产生的任何间接、偶然、特殊或衍生损失承担责任',
          '在任何情况下，运营方依据本协议所承担的累计责任，以您为本产品支付的费用（如有）为限；由于本产品当前阶段的订阅服务可能涉及付费，前述金额以您实际支付的费用为限'
        ]
      },
      updates: {
        title: '八、协议变更',
        content: '运营方有权根据产品迭代、法律法规变化等情况修改本协议。修改后的协议会通过官网公告与扩展内的"版本更新"页面告知。继续使用本产品即视为您接受修改后的协议。'
      },
      dispute: {
        title: '九、争议解决',
        content: '因本协议引起的或与本协议有关的任何争议，双方应首先通过友好协商解决。协商不成的，任何一方可向运营方所在地有管辖权的人民法院提起诉讼。'
      },
      law: {
        title: '十、法律适用',
        content: '本协议的解释、效力及争议解决均适用中华人民共和国（为本协议之目的，不包括香港特别行政区、澳门特别行政区和台湾地区）法律。'
      }
    }
  },


refund: {
  title: '退款政策',
  subtitle: '订阅退款规则与说明',
  meta: '生效日期 · 2026-09-06',
  intro: '本政策约定「隐分宝」Pro 会员订阅服务的退款与补偿规则。「隐分宝」为虚拟数字商品服务，开通即消耗服务资源，故不提供「无理由全额退款」；如你确需退款（且账号经运营方核实开放退款权限），将按已使用天数比例清算，退款金额 = 实付 × 剩余天数 ÷ 套餐天数（向下取分），已使用天数含开通当天，无 100% 退款。请在下单前阅读本政策；点击支付即视为你已了解并同意本政策。',
  sections: {
    scope: {
      title: '一、适用范围',
      content: '本政策适用于运营方向「隐分宝」用户提供的 Pro 会员订阅服务的退款与补偿处理。试用、兑换码、邀请奖励、运营方赠送或调整的权益均不涉及实付出资，不在退款范围内。'
    },
    window: {
      title: '二、退款权限与入口',
      items: [
        '用户侧默认不提供主动退款入口；如因产品问题、系统失误、误购等特殊情况需要退款，可在浏览器扩展的「意见反馈」中说明情况。',
        '运营方核实情况后，可在后台为该用户开放退款权限。权限开放后，其名下「已支付」且仍有剩余天数的订阅订单即可自助申请退款。',
        '退款权限是否开放、何时开放由运营方视具体情况决定，不代表对任何订单的退款承诺。'
      ]
    },
    calc: {
      title: '三、退款金额计算',
      intro: '退款按自然日比例清算，规则如下：',
      items: [
        '已使用天数 = 申请日 − 开通日 + 1（含开通当天；开通当天即申请也计为已用 1 天，无 100% 退款）。',
        '剩余天数 = 套餐总天数 − 已使用天数；剩余天数 ≤ 0 时不可退款。',
        '退款金额 = 实付金额 × 剩余天数 ÷ 套餐总天数（向下取分到分）。示例：开通 30 天月度会员第 3 天申请，退 28/30 的实付金额。',
        '退款金额仅基于本单实付（折后价），不按套餐原价折算；活动价/折扣购买后退款按实付计算。',
        '如因产品问题、系统失误或漏洞影响使用体验，可在浏览器扩展的「反馈」中提交说明，经核实后运营方可能发放 Pro 会员天数补偿（补偿为会员时长，非现金退款），或按上述口径为你开放退款权限。'
      ]
    },
    process: {
      title: '四、申请与处理流程',
      items: [
        '退款权限开放后，在个人中心「我的订单」订单详情中，对状态为「已支付」的订单点击「申请退款」。',
        '弹窗将展示退款明细：开通日期、套餐天数、已使用天数（含今天）、剩余天数、实付金额与本次退款金额，请核对后勾选《退款政策》并确认。',
        '确认后系统自动执行退款并原路退回，无需人工审核；请确认退款明细无误后再提交，提交后不可撤回。',
        '退款发起失败（渠道异常等）：订单停留「退款处理中」，由运营方在后台补退队列人工处理，你可稍后查看订单状态。'
      ]
    },
    notApplicable: {
      title: '五、不适用情形',
      items: [
        '账号未获运营方开放退款权限。',
        '订单对应的付费服务段已全部消耗完毕（剩余天数 ≤ 0）。',
        '试用、兑换码、邀请奖励、运营方赠送或调整的权益（未实付）。',
        '已退款完成的同一订单（终态，不可重复退款）。'
      ]
    },
    coverage: {
      title: '六、服务范围与限制',
      intro: '退款涉及权益折算，请一并了解产品服务的覆盖边界：',
      items: [
        '本产品仅对「支持的网站」中配置的视频页面提供剧透信息遮挡；网站首页、列表页以及不在支持列表中的网站不在服务范围。',
        '直接打开的支持站点视频页面可提供遮挡；从该页面连续打开的其他页面（更深层页面、站内跳转产生的页面）不保证遮挡。',
        '受支持的第三方站点可能随时改版（页面结构、路由、播放器等变化），可能造成遮挡失效、错位或部分失效。运营方会持续适配，但不承诺任何时刻、任何页面的完整遮挡。',
        '网络异常、站点要求登录、地区限制等环境因素导致页面内容变化或无法访问时，防护可能不可用；规则缺失或异常时，产品会显示「防护服务暂时不可用」提示并允许继续观看，运营方不对剧透信息被看到承担赔偿责任。'
      ]
    },
    compensation: {
      title: '七、产品问题补偿',
      content: '为保障 Pro 会员权益：如你在使用过程中遇到产品问题、系统失误或漏洞影响体验，可在浏览器扩展的「反馈」中提交说明（含问题类型与描述）。我们核实为真实问题后，将实时发放 Pro 会员天数补偿（补偿为会员时长，非现金退款），发放结果与官方回复可在扩展「我的反馈」中查看。'
    },
    rewards: {
      title: '八、邀请奖励与退款',
      content: '邀请奖励基于好友的实际开通发放。若好友的订阅订单发生退款，已发放的对应邀请奖励将全额收回（该部分流水标记为已退款），邀请者权益按剩余有效流水重新计算。注册级邀请奖励（+5 天）不因好友退款而回收。'
    },
    termination: {
      title: '九、服务终止',
      content: '如运营方停止提供全部或部分订阅服务，对用户尚未消耗的付费时长，将按本政策口径按比例退还未消耗金额。'
    },
    invoice: {
      title: '十、发票',
      content: '运营方现阶段暂不提供发票。如你确需发票，建议暂缓开通。'
    },
    autoRenew: {
      title: '十一、自动续费',
      content: '当前产品不提供自动续费。如未来上线自动续费，将按法律法规要求对用户进行显著提示与确认，并提供简便的取消途径，届时同步更新本政策。'
    },
    dispute: {
      title: '十二、异议与联系',
      content: "如你对退款结果、金额计算或订单处理有异议，可发送邮件至 woofootball@aliyun.com，我们将在合理期限内复核并回复。"
    }
  }
},

inviteRules: {
  title: '邀请规则',
  subtitle: '隐分宝 Pro 邀请机制说明',
  meta: '更新日期 · 2026-09-06',
  intro: '邀请好友使用隐分宝 Pro，好友与你都能获得奖励。本页说明邀请关系的绑定规则与奖励发放口径。通过邀请链接注册即视为已了解本规则。',
  sections: {
    bind: {
      title: '一、绑定规则',
      items: [
        '通过邀请链接（或填写邀请码）注册新账号时，即与邀请人建立邀请关系，关系终身有效、不可更改或解除。',
        '邀请归因仅在 24 小时内有效：点击邀请链接后 24 小时内完成注册才会计入邀请关系；超过 24 小时链接失效，注册将不绑定任何邀请人。',
        '自己邀请自己无效；已注册的老用户通过链接下单不会补绑邀请关系（下单时如检测到未绑定邀请会先征得你的确认）。',
        '每位用户只有一个邀请码，可在个人中心「我的邀请」中查看与复制。'
      ]
    },
    discount: {
      title: '二、受邀优惠',
      items: [
        '受邀好友首次订阅可享受受邀首单折扣，具体力度以页面展示为准。',
        '首单优惠与限时活动、首订优惠互斥不叠加，系统自动按对你最优惠的一项计算；下单时如存在多个候选折扣，可在收银台自行选择（含不使用优惠）。',
        '任何形式的首次订阅（含活动价）都会消耗首单优惠资格，资格不保留不顺延；退款也不返还首单资格。'
      ]
    },
    reward: {
      title: '三、邀请奖励',
      items: [
        '注册奖励：好友通过你的邀请注册成功后，你立即获得 5 天会员奖励（每自然年通过注册奖励累计最多 365 天）。',
        '订阅奖励：好友首次订阅成功（任意套餐）后，你获得该套餐时长一半的奖励（向上取整；月度 30 天得 15 天、季度 90 天得 45 天、年度 365 天得 183 天）。',
        '订阅奖励每个好友仅发放一次（仅限首次订阅）；好友续费不再触发。'
      ]
    },
    refund: {
      title: '四、退款与收回',
      items: [
        '若好友的首次订阅订单发生退款，你因该订单获得的订阅奖励将被全额收回，权益流水会标记「已收回」并重新计算你的会员到期时间。',
        '注册奖励（+5 天）不因好友退款而收回。',
        '好友退款按天比例清算，与你的奖励收回互不影响：好友实际使用期间的奖励也不保留。'
      ]
    },
    display: {
      title: '五、奖励查询',
      content: '你可在个人中心「我的邀请」查看邀请码、邀请链接与全部邀请奖励流水；「权益流水」中每笔邀请奖励会把来源直接标在记录上（节点 · 好友脱敏账号 · 套餐），被收回的记录标记「已收回」。'
    }
  }
},

  notFound: {
    title: '页面未找到',
    desc: '您访问的页面不存在或已被移除。',
    backHome: '返回首页'
  }
} as const
